
//import { Keyboard } from '@ionic-native/keyboard/ngx';
import { NgModule } from '@angular/core';
import { BrowserModule,HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { RouteReuseStrategy, PreloadingStrategy } from '@angular/router';
import {IonicStorageModule} from '@ionic/storage'
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Camera } from '@ionic-native/camera/ngx';
import { TranslateLoader, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import {LocalNotifications} from '@ionic-native/local-notifications/ngx'
import {AngularFireModule} from '@angular/fire/'
import {AngularFireDatabaseModule} from '@angular/fire/database'
import {AngularFireAuthModule} from '@angular/fire/auth'
import { PopovercompoComponent } from './Components/popovercompo/popovercompo.component'
import { PopovercompoComponent2 } from './Components/popovercompo 2/popovercompo2.component'
import {Diagnostic} from '@ionic-native/diagnostic/ngx'; 
import {CallNumber} from '@ionic-native/call-number/ngx';
import {HttpClientModule,HttpClient,HTTP_INTERCEPTORS} from '@angular/common/http'
import { ValidationPage } from './Pages/validation/validation.page';
import { httpIntercepService } from '../utils/httpIntercep.service';
//import { SQLitePorter } from '@ionic-native/sqlite-porter/ngx';
import { SQLite } from '@ionic-native/sqlite/ngx';
import { AngularFireStorageModule } from '@angular/fire/storage';

import {IonicGestureConfig, } from '../utils/IonicGestureConfig'
import { ResponseCotationPage } from './Components/ResponseCotation/ResponseCotation.page';
import { SouscategorieComponent } from './Components/Composant_Simulateur/Automobile/sous_categories/souscategorie.component';
import { GarantiesAutoComponent } from './Components/garanties/garantiesAuto/garantiesauto.component';
import { myPipeModule } from 'src/utils/Pipe/myPipe.module';
import { IonicSelectableModule } from 'ionic-selectable';
import { PaiesimulateComponent } from './Components/paiesimulate/paiesimulate.component';
import { AutoResPrimeComponent } from './Components/Composant_AffichePrime/Automobile/autoresprime.component';
import { IndivResPrimeComponent } from './Components/Composant_AffichePrime/individuelleAccident/indivresprime.component';
import { SanteResPrimeComponent } from './Components/Composant_AffichePrime/sante/santeresprime.component';
import { VoyResPrimeComponent } from './Components/Composant_AffichePrime/voyage/voyresprime.component';
import { AffichePrimeContenaireComponent } from './Components/Composant_AffichePrime/affichePrime-ContenaireView.component';
import { CompoAfficheprimeDirective } from './Components/Composant_AffichePrime/affichePrimeDir.directive';
import { LivraisonComponent } from './Pages/prime/livraison/livraison.component';
import { BaseAppConfig, APP_CONFIG } from './app.config';
import { CouvertureComponent } from './Components/couverture/couverture.component';
import { MrhResPrimeComponent } from './Components/Composant_AffichePrime/mrh/mrhresprime.component';
import {Network} from '@ionic-native/network/ngx';
import { environment } from 'src/environments/environment.prod';
import { ServiceWorkerModule } from '@angular/service-worker';
//import {AppMinimize} from '@ionic-native/app-minimize/ngx';
//import { BackgroundMode } from '@ionic-native/background-mode/ngx';
// FCM
import { FCM } from "cordova-plugin-fcm-with-dependecy-updated/ionic/ngx"
import { TranferSimulComponent } from './Components/Component_Historiquecotations/Transfert/transfert.component';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { ResumeComponent } from './Components/resume/resume.page';
import { MatExpansionModule } from '@angular/material/expansion';
// import { FCM } from '@ionic-native/fcm/ngx';
//import { environment } from '../environments/environment';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
import { MatStepperModule } from '@angular/material/stepper';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations/'
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { TooltipsmrhComponent } from './Components/Composant_Simulateur/mrh/tooltips/tooltips.component';
import { BackgroundMode,BackgroundModeConfiguration } from '@ionic-native/background-mode/ngx';
// import { Crop } from '@ionic-native/crop/ngx';
import { File } from '@ionic-native/file/ngx';
import { AnimationAppConfig } from './app.animation';
import { proprioComponent } from './Pages/souscription-auto/souscriptionauto-step1/proprio/proprio.component';
import { proprio_mrhComponent } from './Components/Composant_Simulateur/mrh/souscription-mrh/souscriptionmrh-step1/proprio/proprio_mrh.component';
//import { MatExpansionModule } from '@angular/material/expansion';


//import { InAppBrowser } from '@ionic-native';

@NgModule({
  declarations: [
    AppComponent,PopovercompoComponent,TooltipsmrhComponent,
    PopovercompoComponent2,SouscategorieComponent,GarantiesAutoComponent,
    ValidationPage,ResponseCotationPage, PaiesimulateComponent,ResumeComponent,
    AutoResPrimeComponent,IndivResPrimeComponent,SanteResPrimeComponent,VoyResPrimeComponent,
    MrhResPrimeComponent,
    AffichePrimeContenaireComponent,CompoAfficheprimeDirective,LivraisonComponent,CouvertureComponent,
    proprioComponent,proprio_mrhComponent,
    TranferSimulComponent
    // IndividuelleAccidentDirective
  ],
  entryComponents: [
    PopovercompoComponent,PopovercompoComponent2,GarantiesAutoComponent,
    ValidationPage,ResponseCotationPage,PaiesimulateComponent,ResumeComponent,
    SouscategorieComponent,LivraisonComponent,TranferSimulComponent,proprioComponent,
    CouvertureComponent,MrhResPrimeComponent,TooltipsmrhComponent,proprio_mrhComponent,
    AutoResPrimeComponent,IndivResPrimeComponent,SanteResPrimeComponent,VoyResPrimeComponent
  ],
  exports:[AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    IonicStorageModule.forRoot(), 
    // navAnimation:AnimationAppConfig
    IonicModule.forRoot({ _forceStatusbarPadding:true, }),
    myPipeModule,IonicSelectableModule,
    TranslateModule,  
   BrowserAnimationsModule,
   MatExpansionModule,
   //MatStepperModule,
    TranslateModule.forRoot({
      loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    // NotificationPageModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],

  providers: [
   // AppMinimize,
    AppVersion,
    Keyboard,
    StatusBar,
    SplashScreen,
    Diagnostic,  
    CallNumber,
    Network,
    SQLite,
    FCM,
    //Crop,
    File,
    //InAppBrowser,
     BackgroundMode,
    // SQLitePorter,
    { provide: APP_CONFIG, useValue: BaseAppConfig },
      { provide: RouteReuseStrategy,
        useClass: IonicRouteStrategy },
    {provide: HAMMER_GESTURE_CONFIG, useClass: IonicGestureConfig},
    {
      provide:HTTP_INTERCEPTORS,
      useClass:httpIntercepService,
      multi:true,
       
    },
    {
        provide: RouteReuseStrategy,
        useClass: IonicRouteStrategy,
      
     },
    Camera,LocalNotifications
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
